import type {LabMetaData} from '../declarations/labMetaData'

import {LabMetricsMetadata} from '@predict/DomainsLib/gen-api/data-contracts'

export const dtoToPlantLabMetaData = ({
  plantSpecificTag = '',
  uniformTag = '',
  unit = '',
  description = '',
  displayName = '',
  category = ''
}: LabMetricsMetadata): LabMetaData => ({
  plantSpecificTag,
  uniformTag,
  unit,
  description: description.trim(),
  displayName: (displayName || description).trim(),
  category: category.trim()
})
